import giftCardImage from 'assets/images/giftCard.jpg';

import {
  ONLY_PURCHASE,
  LOGIN,
  ADDRESS,
  PAYMENT,
  THANKS,
  PASSWORD,
  FIRST_NAME,
  LAST_NAME,
  ZIP_CODE,
  CITY,
  COUNTRY,
  EMAIL,
  GIFT_BOOK,
} from '../const';

const giftCard = {
  book: {
    id: 'geschenkkarte',
    title: 'Give away a Fintool annual subscription',
    subtitle: '',
    introductions: ['Introduction GiftCard 1', 'Introduction GiftCard 2'],
    image: giftCardImage,
  },
  bookIds: [10],
  getDefaultOption: ({ isPremium, isBasic }) => (isBasic && 1) || (!isPremium && 2) || 0,
  getDefaultStrictMode: ({ isPremium, isBasic }) => Boolean(isBasic || isPremium),
  orderOptions: [GIFT_BOOK],
  purchases: [
    {
      id: 1,
      name: 'Fintool Premium Subscriber',
      tasks: {
        [LOGIN]: () => ({
          banner: {
            title: 'Fintool Premium Subscriber',
            price: 'PriceCHF',
            priceValues: [100],
            propositions: ['1 year Fintool Premium', 'Gift card'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [EMAIL, PASSWORD],
            submitButton: 'Login',
            showAdb: false,
          },
          nextStep: 1,
        }),
        [ADDRESS]: () => ({
          banner: {
            title: 'Fintool Premium Subscriber',
            price: 'PriceCHF',
            priceValues: [100],
            propositions: ['1 year Fintool Premium', 'Gift card'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [ADDRESS, ZIP_CODE, CITY, COUNTRY],
            submitButton: 'Continue',
            showAdb: false,
          },
          navigation: '1/2',
          nextStep: 2,
        }),
        [PAYMENT]: () => ({
          banner: {
            title: 'Fintool Premium Subscriber',
            price: 'PriceCHF',
            priceValues: [100],
            propositions: ['1 year Fintool Premium', 'Gift card'],
          },
          form: { withPromoCode: false },
          navigation: '2/2',
          prevStep: 1,
          nextStep: 3,
          shouldSignUp: false,
          subscribeId: null,
          productId: 10,
        }),
        [THANKS]: () => ({
          form: {
            title: 'Your order is on its way',
            description: 'giftCardThanks',
            button: { name: 'To the Fintool Academy', url: '/akademie' },
          },
        }),
      },
    },
    {
      id: 2,
      name: 'Fintool Basic subscriber',
      tasks: {
        [LOGIN]: () => ({
          banner: {
            title: 'Fintool Basic subscriber',
            price: 'PriceCHF',
            priceValues: [100],
            propositions: ['1 year Fintool Premium', 'Gift card'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [EMAIL, PASSWORD],
            submitButton: 'Login',
            showAdb: false,
          },
          nextStep: 1,
        }),
        [ADDRESS]: () => ({
          banner: {
            title: 'Fintool Basic subscriber',
            price: 'PriceCHF',
            priceValues: [100],
            propositions: ['1 year Fintool Premium', 'Gift card'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [ADDRESS, ZIP_CODE, CITY, COUNTRY],
            submitButton: 'Continue',
            showAdb: false,
          },
          navigation: '1/2',
          nextStep: 2,
        }),
        [PAYMENT]: () => ({
          banner: {
            title: 'Fintool Basic subscriber',
            price: 'PriceCHF',
            priceValues: [100],
            propositions: ['1 year Fintool Premium', 'Gift card'],
          },
          form: { withPromoCode: false },
          navigation: '2/2',
          prevStep: 1,
          nextStep: 3,
          shouldSignUp: false,
          subscribeId: null,
          productId: 10,
        }),
        [THANKS]: () => ({
          form: {
            title: 'Your order is on its way',
            description: 'giftCardThanks',
            button: { name: 'To the Fintool Academy', url: '/akademie' },
          },
        }),
      },
    },
    {
      id: 3,
      name: 'Not a Fintool subscriber',
      tasks: {
        [ONLY_PURCHASE]: () => ({
          banner: {
            title: 'Not a Fintool subscriber',
            price: 'PriceCHF',
            priceValues: [100],
            propositions: ['1 year Fintool Premium', 'Gift card'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [FIRST_NAME, LAST_NAME, ADDRESS, ZIP_CODE, CITY, COUNTRY, EMAIL],
            submitButton: 'Continue',
            showAdb: false,
          },
          navigation: '1/2',
          nextStep: 1,
        }),
        [PAYMENT]: () => ({
          banner: {
            title: 'Not a Fintool subscriber',
            price: 'PriceCHF',
            priceValues: [100],
            propositions: ['1 year Fintool Premium', 'Gift card'],
          },
          form: { withPromoCode: false },
          navigation: '2/2',
          prevStep: 0,
          nextStep: 2,
          shouldSignUp: false,
          subscribeId: null,
          productId: 10,
        }),
        [THANKS]: () => ({
          form: {
            title: 'Your order is on its way',
            description: 'giftCardThanks',
            button: {
              name: 'To the video studio',
              url: '/videos',
            },
          },
        }),
      },
    },
  ],
};

export default giftCard;
